function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PROPERTY_FIELDS = ['API_KEY', 'ATTRIBUTES', 'ATTRIBUTIONS', 'CAPABILITIES', 'CAPABILITIES_STYLES', 'CESIUM_ION', 'CLUSTERING_DISTANCE', 'CREDENTIALS', 'EXTERNAL_VECTOR_STYLES', 'GFI_CONTENT', 'GFI_TYPE', 'GFI_XSLT', 'GROUPS', 'HOVER', 'LOCALIZED_NAMES', 'METADATAID', 'NAME', 'OPACITY', 'ORGANIZATION_NAME', 'REALTIME', 'SINGLE_TILE', 'REFRESH_RATE', 'SCALE', 'COVERAGE', 'SELECTED_TIME', 'SRS', 'VECTOR_STYLES', 'TILE_GRID', 'TIMES', 'URL', 'VERSION', 'WFS_LAYER', 'DECLUTTER'];

// Common fields are enforced on composing model.
var COMMON_PROPERTY_FIELDS = ['ATTRIBUTES', 'GROUPS', 'LOCALIZED_NAMES', 'METADATAID', 'NAME', 'OPACITY', 'ORGANIZATION_NAME', 'SCALE', 'COVERAGE'];
var ALL_VERSIONS = 'all';

/**
 * @private
 * @param {string[]|string} [versions]
 * @return {string[]} Version array
 */
var getValidatedVersions = function getValidatedVersions(versions) {
  if (Array.isArray(versions)) {
    return versions;
  }
  if (typeof versions !== 'string') {
    return;
  }
  return [versions];
};

/**
 * @classdesc Describes available properties for a layer and it's versions.
 */
var LayerComposingModel = /*#__PURE__*/function () {
  /**
   * @param {string[]} fields
   * @param {string[]|string} [versions] Supported layer versions. All versions supported by default.
   * @param {string[]} [skipFields] Fields to skip in constructor. Some layer types don't use all the common fields.
   */
  function LayerComposingModel(fields, versions, skipFields) {
    var _this = this;
    _classCallCheck(this, LayerComposingModel);
    this.versions = getValidatedVersions(versions);
    this.propertyFields = new Map(COMMON_PROPERTY_FIELDS.filter(function (key) {
      return !skipFields ? key : !skipFields.includes(key) ? key : null;
    }).map(function (key) {
      return [key, _this.versions || ALL_VERSIONS];
    }));
    if (Array.isArray(fields)) {
      fields.forEach(function (cur) {
        return _this.setPropertyField(cur, _this.versions);
      });
    }
  }

  /**
   * Registers a property for the layer model.
   *
   * @param {string} field Layer property key. One of LayerComposingModel.PROPERTY_FIELDS.
   * @param {string[]|string} [versions] Layer versions where the property is supported in.
   */
  return _createClass(LayerComposingModel, [{
    key: "setPropertyField",
    value: function setPropertyField(field, versions) {
      if (!field || !PROPERTY_FIELDS.includes(field)) {
        return;
      }
      var validVersions = getValidatedVersions(versions) || this.versions || ALL_VERSIONS;
      if (!validVersions) {
        return;
      }
      this.propertyFields.set(field, validVersions);
    }

    /**
     * To get layer property fields.
     *
     * @param {string} [version] Require fields for a specific layer version.
     * @return {string[]} Property fields for the layer model.
     */
  }, {
    key: "getPropertyFields",
    value: function getPropertyFields(version) {
      if (!version) {
        return Array.from(this.propertyFields.keys());
      }
      return Array.from(this.propertyFields).filter(function (entry) {
        var supportedVersions = entry[1];
        return supportedVersions === ALL_VERSIONS || supportedVersions.includes(version);
      }).map(function (entry) {
        return entry[0];
      });
    }

    /**
     * Set supported layer versions. Overrides add previously set property field versions.
     * @param {string[]|string} [versions] Layer versions where the property is supported in.
     */
  }, {
    key: "setVersions",
    value: function setVersions(versions) {
      this.versions = getValidatedVersions(versions);
      for (var field in this.propertyFields.keys()) {
        this.propertyFields.set(field, this.versions);
      }
    }

    /**
     * @return {string[]} Versions with composing support
     */
  }, {
    key: "getVersions",
    value: function getVersions() {
      if (!this.versions) {
        return [];
      }
      return _toConsumableArray(this.versions);
    }
  }]);
}();
;
// Assign static property fields
PROPERTY_FIELDS.forEach(function (key) {
  LayerComposingModel[key] = key;
});
LayerComposingModel.PROPERTY_FIELDS = PROPERTY_FIELDS;
LayerComposingModel.COMMON_PROPERTY_FIELDS = COMMON_PROPERTY_FIELDS;
Oskari.clazz.defineES('Oskari.mapframework.domain.LayerComposingModel', LayerComposingModel);